import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// local dependencies
import { GoogleMap } from 'modules/googleMap';

/**
 * @desc This window shows shop opening hours with address.
 */
const infoWindowView = ( { address, openHours } ) => {
    return (
        <div className='ui-map-with-stores__info-window'>
            <p className='ui-map-with-stores__info-window__address'>{ address }</p>

            <div className='ui-map-with-stores__info-window__open-hours'>
                {
                    openHours.map( ( item, index ) => {
                        return (
                            <div key={ index } className='ui-map-with-stores__info-window__open-hours__item'>
                                <p className='ui-map-with-stores__info-window__open-hours__item__day'>{ item.day }</p>
                                <p className='ui-map-with-stores__info-window__open-hours__item__time'>{ item.time }</p>
                            </div>
                        );
                    } )
                }
            </div>
        </div>
    );
};

/**
 * @type {object}
 * @desc This component renders a Google Map with locations.
 * When user clicks on the location (marker with label),
 * an info window shows store opening hours and the address.
 *
 * @example
 * import { mapWithStores } from 'ui/views/widgets/mapWithStores';
 */
export const mapWithStores = ( props ) => {

    // extract props
    const { className, mapClassName, ...rest } = props;

    // dynamic class names
    const widgetClassName = classnames( 'ui-map-with-stores', className );

    return (
        <div className={ widgetClassName }>
            <GoogleMap
                { ...rest }
                className={ mapClassName }
                infoWindowView={ infoWindowView }
            />
        </div>
    );
};

// set display name
mapWithStores.displayName = 'mapWithStores';

// set default props
mapWithStores.defaultProps = {};

// prop types
mapWithStores.propTypes = {
    id: PropTypes.string.isRequired,
    locations: PropTypes.array.isRequired,
    className: PropTypes.string,
    mapClassName: PropTypes.string,
};
